ProductVideo = window.ProductVideo ?= {}

ProductVideo.init = ({productVideo}, done) ->
  return done() unless productVideo

  $ =>
    window.webyclip = {}
    window.webyclip.input_params = productVideo

    if 'https:' == document.location.protocol
      $.getScript 'https://6bf746ad5bc91a240a3d-1d8fbdf7ecdc2b67730d7c561f0d1dfd.ssl.cf2.rackcdn.com/webyclip-groupon-pdp-default-loader.min.js'
    else
      $.getScript 'http://code.webyclip.com/webyclip-groupon-pdp-default-loader.min.js'

    done()


module.exports = ProductVideo
